
import { ComputedRecuringPricing } from "@/models/payment/computed-recuring-pricing";
import { printHumanFloat, printLocalDate } from "@/utils/pretty-print";
import Vue from "vue";
import AppPayRow from "./ActivationCardPayRow.vue";

export default Vue.extend({
	filters: {
		printHumanFloat,
		printLocalDate
	},
	props: {
		pricing: {
			type: Object as ()=>ComputedRecuringPricing,
			required: true
		},
		hidePeriod: Boolean
	},
	computed: {
		price():number{
			return this.pricing.priceWithDiscount;
		},
		pricePerMonth():number{
			return this.pricing.priceWithDiscountPerMonth;
		},
		hasVat():boolean{
			return this.pricing.vatPercent != 0;
		},
		vat():number{
			return this.pricing.vat;
		},
		vatPercent():number{
			return this.pricing.vatPercent;
		},
		priceWithVat():number{
			return this.pricing.total;
		},
		interval():string{
			return this.pricing.months == 3 ? this.$ct("sequence-quarter").toString() : this.$ct("sequence-year").toString();
		},
		fromDate(): Date{
			return new Date();
		},
		tillDate(): Date{
			let date = new Date();
			date.setMonth(date.getMonth() + this.pricing.months);
			return date;
		},
		switchIntervalText():string{
			if (this.pricing.months == 3) {
				return this.$ct("switch-year").toString();
			}
			return this.$ct("switch-quarter").toString();
		}
	},
	methods: {
		toggleInterval(){
			this.$emit("toggle-interval");
		}
	},
	components: {
		AppPayRow
	},
	i18nEx: {
		componentPrefix: "components.account"
	}
});
